import { defaultColorMap, defaultForegroundColorMap } from './color-mapper-defaults'

/*
 * Since the address colors are defined in a CSS module they
 * cannot be used in unit tests. Therefore, the following colors
 * need to be semi hard-coded here for the addresses tests to pass.
 */
const GREY = defaultColorMap['grey'] || '#38444d' // grey-125
const WHITE = defaultColorMap['white'] || '#ffffff'

/**
 * Get the background color as hex string of an address color for a given ONTARIO color name,
 * address color code, ATLANTIS color name, or ATLANTIS standard color label.
 * Get the foreground color as hex string depending on the specified contrast.
 * @param {string | number} The color name or code
 * @return {object} {backgroundColor: The hex color string of the address color or white
 *                  if the color could not be found.
 *                  foregroundColor: The hex color string grey125 for colors white, grey15,
 *                  limegreen, yellowold, yellow and aquamarine; white for the rest.
 */
export function getAddressColor(value = 'grey15', colorMap) {
    if (!colorMap) {
        colorMap = defaultColorMap
    }

    const color = {
        backgroundColor: (value && colorMap[value.toString()]) || WHITE,
        foregroundColor: (value && defaultForegroundColorMap[value.toString()]) || WHITE,
        iconBackgroundColor: (value && colorMap[value.toString()]) || WHITE,
        iconForegroundColor: /* (value && defaultForegroundColorMap[value.toString()]) || */ WHITE,
        withBorder: false
    }

    // error handling: prevent white foregroundColor on white backgroundColor
    // can occur when unknown color is provided as parameter
    if (color.backgroundColor === WHITE && value !== 'white') {
        color.foregroundColor = GREY
        color.iconForegroundColor = GREY
        color.withBorder = true
    }
    // if value is white set iconBackgroundColor to white, too
    else if (value === 'grey15' || value === 'white') {
        color.withBorder = true
        color.iconBackgroundColor = WHITE
    }
    return color
}
